import { Service } from '@angular/core';

@Service()
export class StorageService {
    public setItem(key: string, value: unknown): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    public removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    public getItem<T>(item: string): T | null {
        try {
            return <T>JSON.parse(<string>localStorage.getItem(item));
        } catch {
            return null;
        }
    }
}
